import { z } from "zod";
import { REQUIRED_FIELD } from "../../../utils/constants";

export const RolesItemSchema = z.object({
  name: z.string().min(1, { message: REQUIRED_FIELD }),
  organizationLevelOption: z.object({
    id: z.number(),
    name: z.string().min(1, { message: REQUIRED_FIELD }),
  }),
  permissions: z.array(z.string()).min(1, { message: REQUIRED_FIELD }),
});
